<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>
    
    <input matInput [formControlName]="fieldName" [matAutocomplete]="auto" [required]="required">
    
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayAutocompleteField.bind(this)" (optionSelected)='onSelect($event.option.value)'>
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{ option.value }}
        </mat-option>
    </mat-autocomplete>

    <mat-error *ngIf="getFormControlField()?.hasError('required') || getFormControlField()?.hasError('invalid')">
        {{ 'data-table.validation.field-required' | translate }}
    </mat-error>
</mat-form-field>
